import { httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';

export type HmEstimatePackagesRequest = {
  idle_util: number;
  path: {
    lat: number;
    lng: number;
    location_features: string[];
  }[];
};

export type HmEstimatePackagesResponse = any;

export const hmEstimatePackagesFn = async (body: HmEstimatePackagesRequest) => {
  const response = await httpClient.post<HmEstimatePackagesResponse>(
    apiRoutes.service.hmEstimatePackages,
    body
  );
  return response.data;
};
